import { useNavigate } from "react-router-dom"

import ArrowLeftRoundIcon from "../../../assets/icons/ArrowLeftRoundIcon"
import styles from "./index.module.scss"
import { useContext } from "react"
import { FilterContext } from "../../../contexts/Filter"

export default function RcmpBackPageButton(props) {
  const { onClick, ...oRest } = props

  const fnNavigate = useNavigate()
  const { fnSetAFilters, aFilters } = useContext(FilterContext)

  function fnHandleOnClick() {
    if (typeof onClick === "function") {
      onClick()
      return
    }

    fnNavigate(-1)
  }

  return (
    <div className={styles.backPageButtonContainer} onClick={fnHandleOnClick} {...oRest}>
      <ArrowLeftRoundIcon />
    </div>
  )
}
